module.exports = __webpack_public_path__ + "img/sunny.6c61bdb9.svg";